import React from 'react';
import SlideLayout from '../layouts/SlideLayout';
import { FooterProps } from '../types';
import '../styles/MilestoneSlide.css';

export interface Deliverable {
  title: string;
  description: string;
}

export interface MilestoneSlideProps {
  title: string;
  subtitle?: string;
  price: string;
  priceSubtitle?: string;
  deliverables: Deliverable[];
  footer?: FooterProps;
}

const MilestoneSlide: React.FC<MilestoneSlideProps> = ({
  title,
  subtitle,
  price,
  priceSubtitle,
  deliverables,
  footer
}) => {
  return (
    <SlideLayout footer={footer} className="milestone-slide">
      <div className="milestone-content">
        <div className="milestone-header">
          <div className="milestone-header-left">
            <h1 className="milestone-title">{title}</h1>
            {subtitle && <p className="milestone-subtitle">{subtitle}</p>}
          </div>
          <div className="milestone-header-right">
            <p className="milestone-price">{price} — <span>Inversión</span></p>
            {priceSubtitle && <p className="milestone-price-subtitle">{priceSubtitle}</p>}
          </div>
        </div>

        <div className="milestone-deliverables">
          {deliverables.map((item, index) => (
            <div key={index} className="deliverable-item">
              <div className="deliverable-header">
                <span className="deliverable-badge">{String(index + 1).padStart(2, '0')}</span>
                <h3 className="deliverable-title">{item.title}</h3>
              </div>
              <p className="deliverable-description">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </SlideLayout>
  );
};

export default MilestoneSlide;
